export const indiaVsNewzealandContestByCategoryList = [
  {
    _id: '631301f38977f2001ed3422e',
    contests: [
      {
        _id: '63cf7a0ae6b1ab001dcf8f78',
        createdOn: '2023-01-24T06:24:05.983Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H',
        description: 'H2H',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 150000,
        entryFee: 100000,
        winningsPerPosition: {
          '150000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 1
      },
      {
        _id: '63cf7ad6e6b1ab001dcf8f7c',
        createdOn: '2023-01-24T06:29:14.978Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'headtohead',
        description: 'headtohead',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7e67e6b1ab001dcf8f9f',
        createdOn: '2023-01-24T06:44:09.220Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtohead_4',
        description: 'Headtohead_4',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7e67e6b1ab001dcf8fa1',
        createdOn: '2023-01-24T06:42:59.046Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtoheadtest_3',
        description: 'Headtoheadtest_3',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 100000,
        entryFee: 70000,
        winningsPerPosition: {
          '100000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      }
    ]
  },
  {
    _id: '6180fa03b2569b001f9dde16',
    contests: [
      {
        _id: '63cf653ee6b1ab001dcf8f41',
        createdOn: '2022-01-07T07:28:04.605Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'h2h',
        description: 'heAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 800000,
        entryFee: 500000,
        winningsPerPosition: {
          '800000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 1,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63cf7d9ee6b1ab001dcf8f8d',
        createdOn: '2022-03-21T08:19:22.807Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'Small League ',
        description: 'Invest small win big ',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 1800,
        entryFee: 1000,
        winningsPerPosition: {
          '1800': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d9ee6b1ab001dcf8f91',
        createdOn: '2021-11-26T13:13:58.382Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'NEW H2H 20',
        description: 'HEAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 3600,
        entryFee: 2000,
        winningsPerPosition: {
          '3600': 1
        },
        selfReplicating: true,
        bonusPercentage: 2,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 400,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d9ee6b1ab001dcf8f8f',
        createdOn: '2021-11-04T07:06:53.304Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'H2H5',
        description: 'head to head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 900,
        entryFee: 500,
        winningsPerPosition: {
          '900': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d9ee6b1ab001dcf8f93',
        createdOn: '2021-11-26T13:15:29.511Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'NEW H2H 30',
        description: 'HEAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 5200,
        entryFee: 3000,
        winningsPerPosition: {
          '5200': 1
        },
        selfReplicating: true,
        bonusPercentage: 5,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 800,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d9ee6b1ab001dcf8f95',
        createdOn: '2021-11-03T10:40:34.493Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'Test',
        description: 'Test',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 600,
        entryFee: 400,
        winningsPerPosition: {
          '600': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d9ee6b1ab001dcf8f97',
        createdOn: '2021-12-01T11:09:34.975Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'H2h',
        description: 'contest',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 220000,
        entryFee: 115000,
        winningsPerPosition: {
          '220000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 10000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      }
    ]
  },
  {
    _id: '61817f8fb2569b001f9ddedd',
    contests: [
      {
        _id: '63cf7d14e6b1ab001dcf8f80',
        createdOn: '2022-03-04T18:02:10.515Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'mini1',
        description: 'mini1',
        minimumPlayers: 11,
        maximumPlayers: 65,
        maxTeamPerUser: 11,
        winningsAmount: 250000,
        entryFee: 5000,
        winningsPerPosition: {
          '19000': 10,
          '20000': 1,
          '40000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d14e6b1ab001dcf8f82',
        createdOn: '2022-04-13T16:33:58.175Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'gadget_league',
        description: 'oneplusphone.png, OnePlus Nord',
        minimumPlayers: 50000,
        maximumPlayers: 50000,
        maxTeamPerUser: 11,
        winningsAmount: 200,
        entryFee: 100,
        winningsPerPosition: {
          '200': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d14e6b1ab001dcf8f86',
        createdOn: '2022-03-04T18:02:10.515Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'mini1',
        description: 'mini1',
        minimumPlayers: 11,
        maximumPlayers: 65,
        maxTeamPerUser: 11,
        winningsAmount: 250000,
        entryFee: 5000,
        winningsPerPosition: {
          '19000': 10,
          '20000': 1,
          '40000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d14e6b1ab001dcf8f88',
        createdOn: '2022-04-13T16:33:58.175Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'gadget_league',
        description: 'oneplusphone.png, OnePlus Nord',
        minimumPlayers: 50000,
        maximumPlayers: 50000,
        maxTeamPerUser: 11,
        winningsAmount: 200,
        entryFee: 100,
        winningsPerPosition: {
          '200': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      }
    ]
  },
  {
    _id: '61817455b2569b001f9dded3',
    contests: [
      {
        _id: '63cf7fa0e6b1ab001dcf8fab',
        createdOn: '2021-11-26T13:44:49.621Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817455b2569b001f9dded3',
        tenant: 'dev',
        title: 'NEW 100% BONUS',
        description: '100^% BONUS',
        minimumPlayers: 5000,
        maximumPlayers: 5000,
        maxTeamPerUser: 11,
        winningsAmount: 500000,
        entryFee: 3500,
        winningsPerPosition: {
          '500': 200,
          '800': 80,
          '1100': 50,
          '1500': 20,
          '1800': 5,
          '2000': 5,
          '2500': 5,
          '3000': 5,
          '5000': 3,
          '8500': 2,
          '12500': 1,
          '15000': 1,
          '25000': 1,
          '40000': 1,
          '80000': 1
        },
        selfReplicating: false,
        bonusPercentage: 100,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 17000000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7fa0e6b1ab001dcf8faf',
        createdOn: '2022-09-06T08:22:09.547Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817455b2569b001f9dded3',
        tenant: 'dev',
        title: '100% Bonus League',
        description: 'bonus league',
        minimumPlayers: 50,
        maximumPlayers: 50,
        maxTeamPerUser: 11,
        winningsAmount: 2000000,
        entryFee: 140000,
        winningsPerPosition: {
          '2000000': 1
        },
        selfReplicating: false,
        bonusPercentage: 100,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 5000000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7fa0e6b1ab001dcf8fad',
        createdOn: '2022-09-06T08:28:40.145Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817455b2569b001f9dded3',
        tenant: 'dev',
        title: '100% Bonus League 3',
        description: 'bonus',
        minimumPlayers: 22,
        maximumPlayers: 22,
        maxTeamPerUser: 11,
        winningsAmount: 20000000,
        entryFee: 1000000,
        winningsPerPosition: {
          '20000000': 1
        },
        selfReplicating: false,
        bonusPercentage: 100,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 2000000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7fa0e6b1ab001dcf8fb1',
        createdOn: '2022-09-06T08:25:16.805Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817455b2569b001f9dded3',
        tenant: 'dev',
        title: '100% Bonus League 2',
        description: '100% Bonus League 2',
        minimumPlayers: 40,
        maximumPlayers: 40,
        maxTeamPerUser: 11,
        winningsAmount: 5000000,
        entryFee: 200000,
        winningsPerPosition: {
          '5000000': 1
        },
        selfReplicating: false,
        bonusPercentage: 100,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 3000000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf804ce6b1ab001dcf8fb6',
        createdOn: '2023-01-24T06:52:38.490Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817455b2569b001f9dded3',
        tenant: 'dev',
        title: 'multipleplayermultientry100bonus1',
        description: 'multipleplayermultientry100bonus1',
        minimumPlayers: 2,
        maximumPlayers: 100,
        maxTeamPerUser: 5,
        winningsAmount: 200000,
        entryFee: 10000,
        winningsPerPosition: {
          '50000': 1,
          '150000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbb6ed96851a4d7f84726c',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      }
    ]
  }
];

export const saVsEngContestByCategoryList = [
  {
    _id: '61817f8fb2569b001f9ddedd',
    contests: [
      {
        _id: '63d0fa1967b0c2001d35fb40',
        createdOn: '2022-03-04T18:02:10.515Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'mini1',
        description: 'mini1',
        minimumPlayers: 11,
        maximumPlayers: 65,
        maxTeamPerUser: 11,
        winningsAmount: 250000,
        entryFee: 5000,
        winningsPerPosition: {
          '19000': 10,
          '20000': 1,
          '40000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d0d9c596851a4d7f67dcd5',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 2,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d0fa1967b0c2001d35fb44',
        createdOn: '2022-04-13T16:33:58.175Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'gadget_league',
        description: 'oneplusphone.png, OnePlus Nord',
        minimumPlayers: 50000,
        maximumPlayers: 50000,
        maxTeamPerUser: 11,
        winningsAmount: 200,
        entryFee: 100,
        winningsPerPosition: {
          '200': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d0d9c596851a4d7f67dcd5',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d25cd567b0c2001d35fbf8',
        createdOn: '2021-11-28T14:55:38.069Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'Grand League',
        description: 'gl',
        minimumPlayers: 1000,
        maximumPlayers: 1000,
        maxTeamPerUser: 11,
        winningsAmount: 1000000,
        entryFee: 2000,
        winningsPerPosition: {
          '1000': 300,
          '5000': 8,
          '10000': 1,
          '20000': 1,
          '30000': 1,
          '100000': 1,
          '500000': 1
        },
        selfReplicating: false,
        bonusPercentage: 19,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 1000000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d0d9c596851a4d7f67dcd5',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63d25cd567b0c2001d35fbfa',
        createdOn: '2022-03-15T17:41:33.456Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'Gl',
        description: 'Gl',
        minimumPlayers: 100,
        maximumPlayers: 100,
        maxTeamPerUser: 6,
        winningsAmount: 800000,
        entryFee: 10000,
        winningsPerPosition: {
          '50000': 10,
          '100000': 1,
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d0d9c596851a4d7f67dcd5',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63d25cd567b0c2001d35fbfc',
        createdOn: '2022-03-12T07:48:14.810Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'GL Mini',
        description: 'MINI',
        minimumPlayers: 10,
        maximumPlayers: 1000,
        maxTeamPerUser: 11,
        winningsAmount: 2000000,
        entryFee: 4000,
        winningsPerPosition: {
          '4000': 100,
          '10000': 1,
          '20000': 3,
          '30000': 1,
          '500000': 1,
          '1000000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d0d9c596851a4d7f67dcd5',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63d25cd567b0c2001d35fbfe',
        createdOn: '2021-12-02T11:17:47.009Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'Min User',
        description: 'Min User',
        minimumPlayers: 20,
        maximumPlayers: 50,
        maxTeamPerUser: 1,
        winningsAmount: 40000,
        entryFee: 1000,
        winningsPerPosition: {
          '10000': 1,
          '30000': 1
        },
        selfReplicating: false,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d0d9c596851a4d7f67dcd5',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63d25cd567b0c2001d35fc02',
        createdOn: '2022-04-13T16:33:58.175Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'gadget_league',
        description: 'oneplusphone.png, OnePlus Nord',
        minimumPlayers: 50000,
        maximumPlayers: 50000,
        maxTeamPerUser: 11,
        winningsAmount: 200,
        entryFee: 100,
        winningsPerPosition: {
          '200': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d0d9c596851a4d7f67dcd5',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63d25cd567b0c2001d35fc04',
        createdOn: '2022-03-04T18:02:10.515Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'mini1',
        description: 'mini1',
        minimumPlayers: 11,
        maximumPlayers: 65,
        maxTeamPerUser: 11,
        winningsAmount: 250000,
        entryFee: 5000,
        winningsPerPosition: {
          '19000': 10,
          '20000': 1,
          '40000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d0d9c596851a4d7f67dcd5',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      }
    ]
  },
  {
    _id: '618284340d1e16001ef3297e',
    contests: [
      {
        _id: '63d0fa1967b0c2001d35fb42',
        createdOn: '2022-03-09T08:57:40.198Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '618284340d1e16001ef3297e',
        tenant: 'dev',
        title: 'mini23',
        description: 'mini23',
        minimumPlayers: 25,
        maximumPlayers: 25,
        maxTeamPerUser: 11,
        winningsAmount: 200000,
        entryFee: 0,
        winningsPerPosition: {
          '10000': 20
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d0d9c596851a4d7f67dcd5',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      }
    ]
  }
];

export const indVsNzT20ContestByCategoryList = [
  {
    _id: '61817f8fb2569b001f9ddedd',
    contests: [
      {
        _id: '63d25cd567b0c2001d35fbf6',
        createdOn: '2021-11-30T09:12:28.050Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'GL',
        description: 'GL',
        minimumPlayers: 50,
        maximumPlayers: 50,
        maxTeamPerUser: 10,
        winningsAmount: 20000,
        entryFee: 500,
        winningsPerPosition: {
          '500': 10,
          '1000': 1,
          '2000': 1,
          '3000': 1,
          '4000': 1,
          '5000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 5000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63d25cd567b0c2001d35fbf8',
        createdOn: '2021-11-28T14:55:38.069Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'Grand League',
        description: 'gl',
        minimumPlayers: 1000,
        maximumPlayers: 1000,
        maxTeamPerUser: 11,
        winningsAmount: 1000000,
        entryFee: 2000,
        winningsPerPosition: {
          '1000': 300,
          '5000': 8,
          '10000': 1,
          '20000': 1,
          '30000': 1,
          '100000': 1,
          '500000': 1
        },
        selfReplicating: false,
        bonusPercentage: 19,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 1000000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63d25cd567b0c2001d35fbfa',
        createdOn: '2022-03-15T17:41:33.456Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'Gl',
        description: 'Gl',
        minimumPlayers: 100,
        maximumPlayers: 100,
        maxTeamPerUser: 6,
        winningsAmount: 800000,
        entryFee: 10000,
        winningsPerPosition: {
          '50000': 10,
          '100000': 1,
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63d25cd567b0c2001d35fbfc',
        createdOn: '2022-03-12T07:48:14.810Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'GL Mini',
        description: 'MINI',
        minimumPlayers: 10,
        maximumPlayers: 1000,
        maxTeamPerUser: 11,
        winningsAmount: 2000000,
        entryFee: 4000,
        winningsPerPosition: {
          '4000': 100,
          '10000': 1,
          '20000': 3,
          '30000': 1,
          '500000': 1,
          '1000000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63d25cd567b0c2001d35fbfe',
        createdOn: '2021-12-02T11:17:47.009Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'Min User',
        description: 'Min User',
        minimumPlayers: 20,
        maximumPlayers: 50,
        maxTeamPerUser: 1,
        winningsAmount: 40000,
        entryFee: 1000,
        winningsPerPosition: {
          '10000': 1,
          '30000': 1
        },
        selfReplicating: false,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63d25cd567b0c2001d35fc02',
        createdOn: '2022-04-13T16:33:58.175Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'gadget_league',
        description: 'oneplusphone.png, OnePlus Nord',
        minimumPlayers: 50000,
        maximumPlayers: 50000,
        maxTeamPerUser: 11,
        winningsAmount: 200,
        entryFee: 100,
        winningsPerPosition: {
          '200': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63d25cd567b0c2001d35fc04',
        createdOn: '2022-03-04T18:02:10.515Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'mini1',
        description: 'mini1',
        minimumPlayers: 11,
        maximumPlayers: 65,
        maxTeamPerUser: 11,
        winningsAmount: 250000,
        entryFee: 5000,
        winningsPerPosition: {
          '19000': 10,
          '20000': 1,
          '40000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      }
    ]
  },
  {
    _id: '631301f38977f2001ed3422e',
    contests: [
      {
        _id: '63d25c6767b0c2001d35fbde',
        createdOn: '2023-01-24T06:29:14.978Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'headtohead',
        description: 'headtohead',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d25c6767b0c2001d35fbe4',
        createdOn: '2023-01-24T06:44:09.220Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtohead_4',
        description: 'Headtohead_4',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d25c6767b0c2001d35fbee',
        createdOn: '2023-01-24T06:47:47.294Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtohead_5',
        description: 'Headtohead_5',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 300000,
        entryFee: 100000,
        winningsPerPosition: {
          '300000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d25c6767b0c2001d35fbe6',
        createdOn: '2023-01-24T06:29:14.978Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'headtohead',
        description: 'headtohead',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d25c6767b0c2001d35fbec',
        createdOn: '2023-01-24T06:42:59.046Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtoheadtest_3',
        description: 'Headtoheadtest_3',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 100000,
        entryFee: 70000,
        winningsPerPosition: {
          '100000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d25c9267b0c2001d35fbf0',
        createdOn: '2023-01-24T06:29:14.978Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'headtohead',
        description: 'headtohead',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      }
    ]
  },
  {
    _id: '61821e0cb2569b001f9ddf50',
    contests: [
      {
        _id: '63d25c6767b0c2001d35fbe0',
        createdOn: '2022-03-22T10:11:34.371Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 01',
        description: '100 Spots in One contest ',
        minimumPlayers: 100,
        maximumPlayers: 100,
        maxTeamPerUser: 6,
        winningsAmount: 200000,
        entryFee: 2500,
        winningsPerPosition: {
          '2500': 4,
          '3000': 10,
          '5000': 2,
          '10000': 1,
          '20000': 1,
          '30000': 1,
          '40000': 1,
          '50000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 50000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d25c6767b0c2001d35fbe2',
        createdOn: '2022-03-21T09:56:33.446Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Fight of Eight',
        description: '8 teams in one contest',
        minimumPlayers: 8,
        maximumPlayers: 8,
        maxTeamPerUser: 2,
        winningsAmount: 12000,
        entryFee: 2000,
        winningsPerPosition: {
          '1000': 1,
          '2000': 1,
          '4000': 1,
          '5000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 4000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d25c6767b0c2001d35fbea',
        createdOn: '2022-03-22T10:21:44.679Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 02',
        description: '7 teams per user/100 spots',
        minimumPlayers: 200,
        maximumPlayers: 200,
        maxTeamPerUser: 7,
        winningsAmount: 500000,
        entryFee: 3000,
        winningsPerPosition: {
          '5000': 30,
          '10000': 10,
          '25000': 1,
          '40000': 1,
          '50000': 1,
          '60000': 1,
          '75000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d25c6767b0c2001d35fbe8',
        createdOn: '2022-03-22T10:31:45.450Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 03',
        description: '8 teams per user/300 spots',
        minimumPlayers: 300,
        maximumPlayers: 300,
        maxTeamPerUser: 8,
        winningsAmount: 400000,
        entryFee: 1500,
        winningsPerPosition: {
          '2000': 50,
          '3000': 25,
          '5000': 15,
          '10000': 10,
          '15000': 2,
          '20000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 50000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d25cad67b0c2001d35fbf2',
        createdOn: '2022-03-22T10:21:44.679Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 02',
        description: '7 teams per user/100 spots',
        minimumPlayers: 200,
        maximumPlayers: 200,
        maxTeamPerUser: 7,
        winningsAmount: 500000,
        entryFee: 3000,
        winningsPerPosition: {
          '5000': 30,
          '10000': 10,
          '25000': 1,
          '40000': 1,
          '50000': 1,
          '60000': 1,
          '75000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63d25cad67b0c2001d35fbf4',
        createdOn: '2022-03-22T10:31:45.450Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 03',
        description: '8 teams per user/300 spots',
        minimumPlayers: 300,
        maximumPlayers: 300,
        maxTeamPerUser: 8,
        winningsAmount: 400000,
        entryFee: 1500,
        winningsPerPosition: {
          '2000': 50,
          '3000': 25,
          '5000': 15,
          '10000': 10,
          '15000': 2,
          '20000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 50000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cf79bd96851a4d7f28b245',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      }
    ]
  }
];
export const wiWVsIndWT20ContestByCategoryList = [
  {
    _id: '631301f38977f2001ed3422e',
    contests: [
      {
        _id: '63d267cf67b0c2001d35fc10',
        createdOn: '2023-01-24T06:42:59.046Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtoheadtest_3',
        description: 'Headtoheadtest_3',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 100000,
        entryFee: 70000,
        winningsPerPosition: {
          '100000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cc017596851a4d7f92dbc2',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 1,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d267cf67b0c2001d35fc0c',
        createdOn: '2023-01-24T06:44:09.220Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtohead_4',
        description: 'Headtohead_4',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cc017596851a4d7f92dbc2',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d267cf67b0c2001d35fc16',
        createdOn: '2023-01-24T06:24:05.983Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H',
        description: 'H2H',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 150000,
        entryFee: 100000,
        winningsPerPosition: {
          '150000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cc017596851a4d7f92dbc2',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d267cf67b0c2001d35fc18',
        createdOn: '2023-01-24T06:47:47.294Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtohead_5',
        description: 'Headtohead_5',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 300000,
        entryFee: 100000,
        winningsPerPosition: {
          '300000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cc017596851a4d7f92dbc2',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d267cf67b0c2001d35fc1c',
        createdOn: '2023-01-24T06:29:14.978Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'headtohead',
        description: 'headtohead',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cc017596851a4d7f92dbc2',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      }
    ]
  },
  {
    _id: '61821e0cb2569b001f9ddf50',
    contests: [
      {
        _id: '63d267cf67b0c2001d35fc0e',
        createdOn: '2022-03-22T10:11:34.371Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 01',
        description: '100 Spots in One contest ',
        minimumPlayers: 100,
        maximumPlayers: 100,
        maxTeamPerUser: 6,
        winningsAmount: 200000,
        entryFee: 2500,
        winningsPerPosition: {
          '2500': 4,
          '3000': 10,
          '5000': 2,
          '10000': 1,
          '20000': 1,
          '30000': 1,
          '40000': 1,
          '50000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 50000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cc017596851a4d7f92dbc2',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d267cf67b0c2001d35fc1a',
        createdOn: '2022-03-22T10:21:44.679Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 02',
        description: '7 teams per user/100 spots',
        minimumPlayers: 200,
        maximumPlayers: 200,
        maxTeamPerUser: 7,
        winningsAmount: 500000,
        entryFee: 3000,
        winningsPerPosition: {
          '5000': 30,
          '10000': 10,
          '25000': 1,
          '40000': 1,
          '50000': 1,
          '60000': 1,
          '75000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cc017596851a4d7f92dbc2',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d267cf67b0c2001d35fc12',
        createdOn: '2022-03-22T10:31:45.450Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 03',
        description: '8 teams per user/300 spots',
        minimumPlayers: 300,
        maximumPlayers: 300,
        maxTeamPerUser: 8,
        winningsAmount: 400000,
        entryFee: 1500,
        winningsPerPosition: {
          '2000': 50,
          '3000': 25,
          '5000': 15,
          '10000': 10,
          '15000': 2,
          '20000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 50000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cc017596851a4d7f92dbc2',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d267cf67b0c2001d35fc1e',
        createdOn: '2022-03-21T08:38:21.793Z',
        deletedOn: null,
        contestTypeId: '5fd31017dedfcb06b5cd21d4',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Grand league',
        description: 'multiple player, multiple entry, multiple winners',
        minimumPlayers: 100,
        maximumPlayers: 100,
        maxTeamPerUser: 11,
        winningsAmount: 100000,
        entryFee: 1500,
        winningsPerPosition: {
          '10000': 5,
          '50000': 1
        },
        selfReplicating: false,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 50000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cc017596851a4d7f92dbc2',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d267cf67b0c2001d35fc20',
        createdOn: '2022-03-21T09:56:33.446Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Fight of Eight',
        description: '8 teams in one contest',
        minimumPlayers: 8,
        maximumPlayers: 8,
        maxTeamPerUser: 2,
        winningsAmount: 12000,
        entryFee: 2000,
        winningsPerPosition: {
          '1000': 1,
          '2000': 1,
          '4000': 1,
          '5000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 4000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cc017596851a4d7f92dbc2',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      }
    ]
  }
];

export const engWVsAusWU19COntestListByCategoryList = [
  {
    _id: '631301f38977f2001ed3422e',
    contests: [
      {
        _id: '63cf7a0ae6b1ab001dcf8f78',
        createdOn: '2023-01-24T06:24:05.983Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H',
        description: 'H2H',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 150000,
        entryFee: 100000,
        winningsPerPosition: {
          '150000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 1
      },
      {
        _id: '63cf7ad6e6b1ab001dcf8f7c',
        createdOn: '2023-01-24T06:29:14.978Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'headtohead',
        description: 'headtohead',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7e67e6b1ab001dcf8f9f',
        createdOn: '2023-01-24T06:44:09.220Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtohead_4',
        description: 'Headtohead_4',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7e67e6b1ab001dcf8fa1',
        createdOn: '2023-01-24T06:42:59.046Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtoheadtest_3',
        description: 'Headtoheadtest_3',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 100000,
        entryFee: 70000,
        winningsPerPosition: {
          '100000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      }
    ]
  },
  {
    _id: '6180fa03b2569b001f9dde16',
    contests: [
      {
        _id: '63cf653ee6b1ab001dcf8f41',
        createdOn: '2022-01-07T07:28:04.605Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'h2h',
        description: 'heAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 800000,
        entryFee: 500000,
        winningsPerPosition: {
          '800000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 1,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63cf7d9ee6b1ab001dcf8f8d',
        createdOn: '2022-03-21T08:19:22.807Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'Small League ',
        description: 'Invest small win big ',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 1800,
        entryFee: 1000,
        winningsPerPosition: {
          '1800': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d9ee6b1ab001dcf8f91',
        createdOn: '2021-11-26T13:13:58.382Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'NEW H2H 20',
        description: 'HEAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 3600,
        entryFee: 2000,
        winningsPerPosition: {
          '3600': 1
        },
        selfReplicating: true,
        bonusPercentage: 2,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 400,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d9ee6b1ab001dcf8f8f',
        createdOn: '2021-11-04T07:06:53.304Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'H2H5',
        description: 'head to head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 900,
        entryFee: 500,
        winningsPerPosition: {
          '900': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d9ee6b1ab001dcf8f93',
        createdOn: '2021-11-26T13:15:29.511Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'NEW H2H 30',
        description: 'HEAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 5200,
        entryFee: 3000,
        winningsPerPosition: {
          '5200': 1
        },
        selfReplicating: true,
        bonusPercentage: 5,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 800,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d9ee6b1ab001dcf8f95',
        createdOn: '2021-11-03T10:40:34.493Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'Test',
        description: 'Test',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 600,
        entryFee: 400,
        winningsPerPosition: {
          '600': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d9ee6b1ab001dcf8f97',
        createdOn: '2021-12-01T11:09:34.975Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'H2h',
        description: 'contest',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 220000,
        entryFee: 115000,
        winningsPerPosition: {
          '220000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 10000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      }
    ]
  },
  {
    _id: '61817f8fb2569b001f9ddedd',
    contests: [
      {
        _id: '63cf7d14e6b1ab001dcf8f80',
        createdOn: '2022-03-04T18:02:10.515Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'mini1',
        description: 'mini1',
        minimumPlayers: 11,
        maximumPlayers: 65,
        maxTeamPerUser: 11,
        winningsAmount: 250000,
        entryFee: 5000,
        winningsPerPosition: {
          '19000': 10,
          '20000': 1,
          '40000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d14e6b1ab001dcf8f82',
        createdOn: '2022-04-13T16:33:58.175Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'gadget_league',
        description: 'oneplusphone.png, OnePlus Nord',
        minimumPlayers: 50000,
        maximumPlayers: 50000,
        maxTeamPerUser: 11,
        winningsAmount: 200,
        entryFee: 100,
        winningsPerPosition: {
          '200': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d14e6b1ab001dcf8f86',
        createdOn: '2022-03-04T18:02:10.515Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'mini1',
        description: 'mini1',
        minimumPlayers: 11,
        maximumPlayers: 65,
        maxTeamPerUser: 11,
        winningsAmount: 250000,
        entryFee: 5000,
        winningsPerPosition: {
          '19000': 10,
          '20000': 1,
          '40000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7d14e6b1ab001dcf8f88',
        createdOn: '2022-04-13T16:33:58.175Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'gadget_league',
        description: 'oneplusphone.png, OnePlus Nord',
        minimumPlayers: 50000,
        maximumPlayers: 50000,
        maxTeamPerUser: 11,
        winningsAmount: 200,
        entryFee: 100,
        winningsPerPosition: {
          '200': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      }
    ]
  },
  {
    _id: '61817455b2569b001f9dded3',
    contests: [
      {
        _id: '63cf7fa0e6b1ab001dcf8fab',
        createdOn: '2021-11-26T13:44:49.621Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817455b2569b001f9dded3',
        tenant: 'dev',
        title: 'NEW 100% BONUS',
        description: '100^% BONUS',
        minimumPlayers: 5000,
        maximumPlayers: 5000,
        maxTeamPerUser: 11,
        winningsAmount: 500000,
        entryFee: 3500,
        winningsPerPosition: {
          '500': 200,
          '800': 80,
          '1100': 50,
          '1500': 20,
          '1800': 5,
          '2000': 5,
          '2500': 5,
          '3000': 5,
          '5000': 3,
          '8500': 2,
          '12500': 1,
          '15000': 1,
          '25000': 1,
          '40000': 1,
          '80000': 1
        },
        selfReplicating: false,
        bonusPercentage: 100,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 17000000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7fa0e6b1ab001dcf8faf',
        createdOn: '2022-09-06T08:22:09.547Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817455b2569b001f9dded3',
        tenant: 'dev',
        title: '100% Bonus League',
        description: 'bonus league',
        minimumPlayers: 50,
        maximumPlayers: 50,
        maxTeamPerUser: 11,
        winningsAmount: 2000000,
        entryFee: 140000,
        winningsPerPosition: {
          '2000000': 1
        },
        selfReplicating: false,
        bonusPercentage: 100,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 5000000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7fa0e6b1ab001dcf8fad',
        createdOn: '2022-09-06T08:28:40.145Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817455b2569b001f9dded3',
        tenant: 'dev',
        title: '100% Bonus League 3',
        description: 'bonus',
        minimumPlayers: 22,
        maximumPlayers: 22,
        maxTeamPerUser: 11,
        winningsAmount: 20000000,
        entryFee: 1000000,
        winningsPerPosition: {
          '20000000': 1
        },
        selfReplicating: false,
        bonusPercentage: 100,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 2000000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf7fa0e6b1ab001dcf8fb1',
        createdOn: '2022-09-06T08:25:16.805Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817455b2569b001f9dded3',
        tenant: 'dev',
        title: '100% Bonus League 2',
        description: '100% Bonus League 2',
        minimumPlayers: 40,
        maximumPlayers: 40,
        maxTeamPerUser: 11,
        winningsAmount: 5000000,
        entryFee: 200000,
        winningsPerPosition: {
          '5000000': 1
        },
        selfReplicating: false,
        bonusPercentage: 100,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 3000000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63cf804ce6b1ab001dcf8fb6',
        createdOn: '2023-01-24T06:52:38.490Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61817455b2569b001f9dded3',
        tenant: 'dev',
        title: 'multipleplayermultientry100bonus1',
        description: 'multipleplayermultientry100bonus1',
        minimumPlayers: 2,
        maximumPlayers: 100,
        maxTeamPerUser: 5,
        winningsAmount: 200000,
        entryFee: 10000,
        winningsPerPosition: {
          '50000': 1,
          '150000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d166dc96851a4d7f804920',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      }
    ]
  }
];
export const saWVsIndWContestListByCategoryList = [
  {
    _id: '61821e0cb2569b001f9ddf50',
    contests: [
      {
        _id: '63d294d767b0c2001d35fc3b',
        createdOn: '2022-03-22T10:21:44.679Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 02',
        description: '7 teams per user/100 spots',
        minimumPlayers: 200,
        maximumPlayers: 200,
        maxTeamPerUser: 7,
        winningsAmount: 500000,
        entryFee: 3000,
        winningsPerPosition: {
          '5000': 30,
          '10000': 10,
          '25000': 1,
          '40000': 1,
          '50000': 1,
          '60000': 1,
          '75000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc47',
        createdOn: '2022-03-22T10:31:45.450Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 03',
        description: '8 teams per user/300 spots',
        minimumPlayers: 300,
        maximumPlayers: 300,
        maxTeamPerUser: 8,
        winningsAmount: 400000,
        entryFee: 1500,
        winningsPerPosition: {
          '2000': 50,
          '3000': 25,
          '5000': 15,
          '10000': 10,
          '15000': 2,
          '20000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 50000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc4b',
        createdOn: '2022-03-21T09:56:33.446Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Fight of Eight',
        description: '8 teams in one contest',
        minimumPlayers: 8,
        maximumPlayers: 8,
        maxTeamPerUser: 2,
        winningsAmount: 12000,
        entryFee: 2000,
        winningsPerPosition: {
          '1000': 1,
          '2000': 1,
          '4000': 1,
          '5000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 4000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 2,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc4f',
        createdOn: '2022-03-22T10:11:34.371Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 01',
        description: '100 Spots in One contest ',
        minimumPlayers: 100,
        maximumPlayers: 100,
        maxTeamPerUser: 6,
        winningsAmount: 200000,
        entryFee: 2500,
        winningsPerPosition: {
          '2500': 4,
          '3000': 10,
          '5000': 2,
          '10000': 1,
          '20000': 1,
          '30000': 1,
          '40000': 1,
          '50000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 50000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      }
    ]
  },
  {
    _id: '6180fa03b2569b001f9dde16',
    contests: [
      {
        _id: '63d294d767b0c2001d35fc31',
        createdOn: '2021-11-26T13:15:29.511Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'NEW H2H 30',
        description: 'HEAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 5200,
        entryFee: 3000,
        winningsPerPosition: {
          '5200': 1
        },
        selfReplicating: true,
        bonusPercentage: 5,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 800,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc41',
        createdOn: '2022-03-21T08:19:22.807Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'Small League ',
        description: 'Invest small win big ',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 1800,
        entryFee: 1000,
        winningsPerPosition: {
          '1800': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc33',
        createdOn: '2021-12-01T11:09:34.975Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'H2h',
        description: 'contest',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 220000,
        entryFee: 115000,
        winningsPerPosition: {
          '220000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 10000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc39',
        createdOn: '2021-11-03T10:40:34.493Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'Test',
        description: 'Test',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 600,
        entryFee: 400,
        winningsPerPosition: {
          '600': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc3f',
        createdOn: '2021-11-26T13:16:54.011Z',
        deletedOn: null,
        contestTypeId: '5fd31017dedfcb06b5cd21d1',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'NEW H2H 40',
        description: 'HEAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 7000,
        entryFee: 4000,
        winningsPerPosition: {
          '7000': 1
        },
        selfReplicating: true,
        bonusPercentage: 20,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 1000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc49',
        createdOn: '2021-11-26T13:13:58.382Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'NEW H2H 20',
        description: 'HEAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 3600,
        entryFee: 2000,
        winningsPerPosition: {
          '3600': 1
        },
        selfReplicating: true,
        bonusPercentage: 2,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 400,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc4d',
        createdOn: '2021-11-04T07:06:53.304Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'H2H5',
        description: 'head to head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 900,
        entryFee: 500,
        winningsPerPosition: {
          '900': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      }
    ]
  },
  {
    _id: '631301f38977f2001ed3422e',
    contests: [
      {
        _id: '63d294d767b0c2001d35fc3d',
        createdOn: '2023-01-24T06:47:47.294Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtohead_5',
        description: 'Headtohead_5',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 300000,
        entryFee: 100000,
        winningsPerPosition: {
          '300000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc45',
        createdOn: '2023-01-24T06:29:14.978Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'headtohead',
        description: 'headtohead',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc35',
        createdOn: '2023-01-24T06:24:05.983Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H',
        description: 'H2H',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 150000,
        entryFee: 100000,
        winningsPerPosition: {
          '150000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc37',
        createdOn: '2023-01-24T06:42:59.046Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtoheadtest_3',
        description: 'Headtoheadtest_3',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 100000,
        entryFee: 70000,
        winningsPerPosition: {
          '100000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc43',
        createdOn: '2023-01-24T06:44:09.220Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtohead_4',
        description: 'Headtohead_4',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      }
    ]
  }
];
export const indWVsNzWU19COntestListByCategoryList = [
  {
    _id: '6180fa03b2569b001f9dde16',
    contests: [
      {
        _id: '63d2958167b0c2001d35fc55',
        createdOn: '2021-12-01T11:09:34.975Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'H2h',
        description: 'contest',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 220000,
        entryFee: 115000,
        winningsPerPosition: {
          '220000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 10000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d2958167b0c2001d35fc57',
        createdOn: '2021-11-26T13:13:58.382Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'NEW H2H 20',
        description: 'HEAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 3600,
        entryFee: 2000,
        winningsPerPosition: {
          '3600': 1
        },
        selfReplicating: true,
        bonusPercentage: 2,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 400,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d2958167b0c2001d35fc63',
        createdOn: '2021-11-26T13:16:54.011Z',
        deletedOn: null,
        contestTypeId: '5fd31017dedfcb06b5cd21d1',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'NEW H2H 40',
        description: 'HEAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 7000,
        entryFee: 4000,
        winningsPerPosition: {
          '7000': 1
        },
        selfReplicating: true,
        bonusPercentage: 20,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 1000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d2958167b0c2001d35fc5f',
        createdOn: '2021-11-04T07:06:53.304Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'H2H5',
        description: 'head to head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 900,
        entryFee: 500,
        winningsPerPosition: {
          '900': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d2958167b0c2001d35fc61',
        createdOn: '2021-11-26T13:07:05.236Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'NEW H2H 10',
        description: 'HEAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 1900,
        entryFee: 1000,
        winningsPerPosition: {
          '1900': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d2958267b0c2001d35fc6f',
        createdOn: '2021-11-26T13:15:29.511Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'NEW H2H 30',
        description: 'HEAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 5200,
        entryFee: 3000,
        winningsPerPosition: {
          '5200': 1
        },
        selfReplicating: true,
        bonusPercentage: 5,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 800,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      }
    ]
  },
  {
    _id: '61821e0cb2569b001f9ddf50',
    contests: [
      {
        _id: '63d2958167b0c2001d35fc51',
        createdOn: '2022-03-21T09:56:33.446Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Fight of Eight',
        description: '8 teams in one contest',
        minimumPlayers: 8,
        maximumPlayers: 8,
        maxTeamPerUser: 2,
        winningsAmount: 12000,
        entryFee: 2000,
        winningsPerPosition: {
          '1000': 1,
          '2000': 1,
          '4000': 1,
          '5000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 4000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 2,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d2958167b0c2001d35fc5b',
        createdOn: '2022-03-22T10:31:45.450Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 03',
        description: '8 teams per user/300 spots',
        minimumPlayers: 300,
        maximumPlayers: 300,
        maxTeamPerUser: 8,
        winningsAmount: 400000,
        entryFee: 1500,
        winningsPerPosition: {
          '2000': 50,
          '3000': 25,
          '5000': 15,
          '10000': 10,
          '15000': 2,
          '20000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 50000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d2958267b0c2001d35fc67',
        createdOn: '2022-03-22T10:11:34.371Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 01',
        description: '100 Spots in One contest ',
        minimumPlayers: 100,
        maximumPlayers: 100,
        maxTeamPerUser: 6,
        winningsAmount: 200000,
        entryFee: 2500,
        winningsPerPosition: {
          '2500': 4,
          '3000': 10,
          '5000': 2,
          '10000': 1,
          '20000': 1,
          '30000': 1,
          '40000': 1,
          '50000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 50000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d2958267b0c2001d35fc6d',
        createdOn: '2022-03-22T10:21:44.679Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 02',
        description: '7 teams per user/100 spots',
        minimumPlayers: 200,
        maximumPlayers: 200,
        maxTeamPerUser: 7,
        winningsAmount: 500000,
        entryFee: 3000,
        winningsPerPosition: {
          '5000': 30,
          '10000': 10,
          '25000': 1,
          '40000': 1,
          '50000': 1,
          '60000': 1,
          '75000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      }
    ]
  },
  {
    _id: '631301f38977f2001ed3422e',
    contests: [
      {
        _id: '63d2958167b0c2001d35fc59',
        createdOn: '2023-01-24T06:44:09.220Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtohead_4',
        description: 'Headtohead_4',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d2958167b0c2001d35fc53',
        createdOn: '2023-01-24T06:47:47.294Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtohead_5',
        description: 'Headtohead_5',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 300000,
        entryFee: 100000,
        winningsPerPosition: {
          '300000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d2958167b0c2001d35fc5d',
        createdOn: '2023-01-24T06:24:05.983Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H',
        description: 'H2H',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 150000,
        entryFee: 100000,
        winningsPerPosition: {
          '150000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d2958267b0c2001d35fc6b',
        createdOn: '2023-01-24T06:29:14.978Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'headtohead',
        description: 'headtohead',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d2958267b0c2001d35fc65',
        createdOn: '2023-01-24T06:42:59.046Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtoheadtest_3',
        description: 'Headtoheadtest_3',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 100000,
        entryFee: 70000,
        winningsPerPosition: {
          '100000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d2958267b0c2001d35fc69',
        createdOn: '2023-01-24T06:29:14.978Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'headtohead',
        description: 'headtohead',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63d1792496851a4d7f831eb1',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      }
    ]
  }
];
